import { mySlideToggle } from './function-slidetoggle.js';
import { mySlideDown } from './function-slidedown.js';
import { mySlideUp } from './function-slideup.js';

export const langSelect = (e) => {

	e.preventDefault();
	e.stopPropagation();

	var thisTarget = e.currentTarget;
	var dt = thisTarget.closest('dt');
	var dd = dt.nextElementSibling;

	if(thisTarget.getAttribute('aria-expanded') === 'false'){
		thisTarget.setAttribute('aria-expanded', true);
		dd.setAttribute('aria-hidden', false);
		mySlideDown(dd);
	} else {
		thisTarget.setAttribute('aria-expanded', false);
		dd.setAttribute('aria-hidden', true);
		mySlideUp(dd);
	}
}

window.langSelect = langSelect;